import { render, staticRenderFns } from "./bankPopup.vue?vue&type=template&id=1861dd48&scoped=true"
import script from "./bankPopup.vue?vue&type=script&lang=ts"
export * from "./bankPopup.vue?vue&type=script&lang=ts"
import style0 from "./bankPopup.vue?vue&type=style&index=0&id=1861dd48&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1861dd48",
  null
  
)

export default component.exports